module.exports = __webpack_public_path__ + "media/images/background/login-register-e775e150a06288843f2af7e99414c7c6.jpg";